<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      timeIndex: null,
    };
  },
  mounted() {
    if (process.env.NODE_ENV === "development") {
       //开发环境不启用分辨率自适应函数,方便写页面。
      console.log("开发环境");
    } else {
      //生产环境启用分辨率自适应函数。
      setTimeout(() => {
        this.openWindowResize();
      }, 200);
      console.log("生产环境");
    }
  },
  destroyed() {
    window.onresize = null;
  },
  methods: {
    // 启动分辨率自适应函数
    openWindowResize() {
      this.keepFit(1920, 1080, "#app");
      window.onresize = () => {
        if (this.timeIndex) {
          clearTimeout(this.timeIndex);
        }
        this.timeIndex = setTimeout(() => {
          this.keepFit(1920, 1080, "#app");
        }, 600);
      };
    },
    //适配不同分辨率大屏
    keepFit(designWidth, designHeight, renderDom) {
      let clientHeight = document.documentElement.clientHeight;
      let clientWidth = document.documentElement.clientWidth;
      var scalex = 1;
      scalex = clientWidth / designWidth;
      document.querySelector(renderDom).style.width = `${
        clientWidth / scalex
      }px`;
      document.querySelector(renderDom).style.transform = `scale(${scalex})`;
      console.log(designHeight, clientHeight);
    },
  },
};
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
}
/* 大屏自动适配样式勿动 */
#app {
  transform-origin: 0 0;
  position: absolute;
  transition: 0.3s;
}
/* 大屏自动适配样式勿动 */
</style>
